"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import CustomImage from "../CustomImage";
import SwiperTestimonialsButtons from "../SwiperTestimonialsButtons";
import { useWindowSize } from "@/hooks/useWindowSize";

type ImageType = {
  src: {
    desktop: string;
    tablet: string;
    mobile: string;
  };
  alt: string;
};

type ImageSliderProps = {
  images: ImageType[];
};

const ImageSlider = ({ images }: ImageSliderProps) => {
  const { width } = useWindowSize();
  return (
    <>
      {width <= 992 ? (
        <Swiper
          slidesPerView={2}
          spaceBetween={10}
          loop
          breakpoints={{
            768: {
              slidesPerView: 3,
            },
          }}
          className="text-block-with-list-and-image__multiple-image-holder"
        >
          {images.map((image) => (
            <SwiperSlide key={image.src.desktop}>
              <CustomImage
                alt={image.alt}
                src={image.src.desktop}
                srcTablet={image.src.tablet}
                srcMobile={image.src.mobile}
              />
            </SwiperSlide>
          ))}
          <SwiperTestimonialsButtons />
        </Swiper>
      ) : (
        <div className="text-block-with-list-and-image__multiple-image-holder">
          {images.map((image) => (
            <CustomImage
              key={image.src.desktop}
              alt={image.alt}
              src={image.src.desktop}
              srcTablet={image.src.tablet}
              srcMobile={image.src.mobile}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default ImageSlider;
